(function () {
  'use strict';

  angular
      .module('tfc.retailer.Brand')
      .factory('BrandAffinityReport', BrandAffinityReport);

  // @ngInject
  function BrandAffinityReport($q, util, Upload, ExcelReportType, GaUtil, Api){

    return {
      downloadReport : downloadReport
    };

    function generateURL(type) {
      var BASE_URL = '/brand/report/affinity';
      return BASE_URL + '/' + type;
    }

    function content(type, selectedBrandKey, selectedTimeFrame, selectedFocusDepartment, selectedFocusCategory,
                     selectedAffinityDepartment, selectedAffinityCategory,region,transaction,fields,
                     isActivityExist, isRegionExist) {
      return Api.get(generateURL(type + 'Report'), {
        cache : false,
        // remove all empty values
        params: _.pickBy({
          brandKey: selectedBrandKey,
          timeFrame: selectedTimeFrame,
          focusDepartment: selectedFocusDepartment,
          focusCategory: selectedFocusCategory,
          affinityDepartment: selectedAffinityDepartment,
          affinityCategory: selectedAffinityCategory,
          region: region,
          transaction: transaction,
          fields:fields,
          addTransactionHeader: isActivityExist,
          addRegionHeader: isRegionExist
        },_.identity),
        responseType : 'arraybuffer',
        headers: {
          'Accept': ExcelReportType
        }
      }).then(function (response) {
        var disposition = util.parseMultipartHeader(response.headers('content-disposition'));
        return $q.all({
          fileName: disposition.filename,
          dataBlob: new Blob([response.data], { type : disposition['content-type'] })
        });
      });
    }

    function downloadReport(type, selectedBrandKey, selectedTimeFrame, selectedFocusDepartment, selectedFocusCategory,
                            selectedAffinityDepartment, selectedAffinityCategory,region,transaction,fields,
                            isActivityExist, isRegionExist) {
      return $q.when(content(type, selectedBrandKey, selectedTimeFrame, selectedFocusDepartment, selectedFocusCategory,
          selectedAffinityDepartment, selectedAffinityCategory,region,transaction,fields,isActivityExist, isRegionExist))
          .then(function (content) {
            download(content.dataBlob, content.fileName, ExcelReportType);
            GaUtil.sendGaEvent(selectedBrandKey, 'Download Report', 'Brand Affinity Report');
          });
    }
  }

})();
